import React from 'react';

const TitleList = ({ children }) => (
  <li className="mx-0">
    <span className="font-bold text-xs cursor-default menu-opacity-transition">{children}</span>
  </li>
);

export default TitleList;
